export interface IPolicy{
    policyNumber?: string;
    effectiveDate?: Date;
    expirationDate?: Date;
    insured?: string;
    policyType?: string;
    properties?: IPolicyProperties[];
    ref5?: string;
    ref6?: string;
}

export interface IPolicyDateRange {
    effectiveDate?: Date;
    expirationDate?: Date;
}

export interface IPolicies {
  addressLine1_Ext?: string;
  addressLine2_Ext?: string;
  address?: string;
  city?: string;
  effectiveDate?: Date;
  expirationDate?: Date;
  cancellationDate?: any;
  insured?: string;
  policyNumber?: string;
  policyType?: PolicyType;
  state?: string;
  zip?: string;
  policyCountry_Ext?: string; 
  policySource?: string;
  accountNumber?: string;
  dashboardInfo?: any;
  tntindicator?: string;
  ref1?: string;
  ref2?: string;
  ref6?: string;
  ref5?: string;
  subPolicyType?: string;
  coverageType?: string;
  productName?: string;
  dW_Banner?: any;
  dW_Profile?: any;
  hasTCCoverage?: boolean;
  policyTypeIndicator?: string;
  sspIndicator?: boolean;
  commerceGuardIndicator?: boolean;
}

export interface PolicyType {
  key?: string;
  value?: string;
}

export interface IPolicyProperties{
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
}

export interface CoverageDeductibleInterface {
  coveragePartName?: string;
  coverage?: {
    coverageName?: string;
    geographicMovement?: {
      name?: string;
      limitVal?: string;
      deductibleVal?: string;
      deductibleType?: string;
    }[];
  }[];
}

export enum POLICYTYPES {
  TRANSACTIONAL_PARCEL = 'transactional_parcel',  //flex  //IS4UPS
  TRADITIONAL_CARGO = 'traditional_cargo',  //Complete  //cargo
  TRANSACTIONAL_CARGO = 'transactional_cargo',  //Connect
  UNKNOWN = 'unknown'
}
